import moment from 'moment'
import pmsApi from 'services/api/pms'

import styles from './LogRow.module.scss'

const statusNames = {
  Started: 'Started',
  StartingAnalysis: 'In progress',
  Finished: 'Finished',
  Cancelled: 'Cancelled',
  Failed: 'Failed',
  DeletingStarted: 'Deleting started',
  Deleted: 'Deleted',
  MigrationStarted: 'Migration started',
  Migrated: 'Migrated'
}

const pmsSourceNames = {
  Api: 'API integration',
  Manual: 'Manual upload',
  Ui: 'User interface'
}

const UploadLogRow = ({
  numberOfTotalRecords,
  numberOfNewSubscribers,
  numberOfUnUsableData,
  numberOfDuplicates,
  numberOfUpdatedSubscribers,
  uploadStatus,
  completedOn,
  deletedOn,
  deletedFullName,
  numberOfRecordsInProgress,
  beginDate,
  reportBeginDate,
  reportEndDate,
  endDate,
  id,
  isEditing,
  selectedRows,
  setSelectedRows,
  pmsSource,
  pmsEmail
}) => {
  const isRowSelected = selectedRows.includes(id)
  const formattedBeginDate =
    reportBeginDate && reportBeginDate !== '0001-01-01T00:00:00'
      ? moment(reportBeginDate).format('MMM D YYYY')
      : moment(beginDate).format('MMM D YYYY')

  const formattedEndDate =
    reportEndDate && reportEndDate !== '0001-01-01T00:00:00'
      ? moment(reportEndDate).format('MMM D YYYY')
      : moment(endDate).format('MMM D YYYY')

  const onRowClick = () => {
    if (isEditing) {
      setSelectedRows(prev => {
        if (prev.includes(id)) {
          return prev.filter(rowId => rowId !== id)
        }

        return [...prev, id]
      })
    }
  }

  function downloadReport() {
    pmsApi.download({ reportId: id }).then(res => {
      res.forEach(element => {
        window.open(element.tempPublicPath)
      })
    })
  }

  return (
    <div className={styles.row}>
      <div className={styles.uploadedByCol} onClick={onRowClick}>
        {!isEditing ? (
          <i className={styles[pmsSource]} />
        ) : isRowSelected ? (
          <i className={styles.checkedIcon} />
        ) : (
          <i className={styles.uncheckedIcon} />
        )}
        {pmsSource === 'Email' ? pmsEmail ?? '-' : pmsSourceNames[pmsSource]}
      </div>

      <div className={styles.iconCol}>
        <i className={styles.calendarIcon} />
        {numberOfTotalRecords}
      </div>

      <div className={styles.iconCol}>
        <i className={styles.userIcon} />
        {numberOfNewSubscribers + numberOfUpdatedSubscribers + numberOfDuplicates}
      </div>

      <div className={styles.col} />

      <div className={styles.uploadedNumberCol}>
        <p className={styles.newText}>NEW {numberOfNewSubscribers}</p>
      </div>
      <div className={styles.uploadedNumberCol}>
        <p className={styles.existText}>EXIST {numberOfUpdatedSubscribers}</p>
      </div>
      <div className={styles.uploadedNumberCol}>
        <p className={styles.duplicateText}>DUP {numberOfDuplicates}</p>
      </div>
      <div className={styles.uploadedNumberCol}>
        <p className={styles.invalidText}>INV {numberOfUnUsableData}</p>
      </div>
      <div className={styles.uploadedNumberCol}>
        <p className={styles.inprogressText}>INP {numberOfRecordsInProgress}</p>
      </div>

      <div className={styles.col} />

      <div className={styles.dateCol}>
        <p className={styles.dateText}>
          {formattedBeginDate} - {formattedEndDate}
        </p>
        <div className={styles.downloadRow} onClick={downloadReport}>
          <i className={styles.downloadIcon} />
          <span className={styles.downloadText}>Download</span>
        </div>
      </div>

      <div className={styles.col} />

      {uploadStatus !== 'DeletingStarted' && uploadStatus !== 'Deleted' && (
        <div className={styles.statusCol}>
          <span className={styles.title}>Recieved</span>
          <span className={styles.subTitle}>{moment(0).format('hh:mm A')}</span>
        </div>
      )}

      <div
        className={
          uploadStatus !== 'DeletingStarted' && uploadStatus !== 'Deleted'
            ? styles.statusCol
            : styles.statusCol2
        }
      >
        <span className={styles.title} style={{ color: getStatusColor(uploadStatus) }}>
          {statusNames[uploadStatus]}
        </span>
        {uploadStatus !== 'DeletingStarted' && uploadStatus !== 'Deleted' ? (
          <span className={styles.subTitle}>{moment(completedOn).format('hh:mm A')}</span>
        ) : (
          <>
            <span className={styles.subTitle}>
              {moment(deletedOn).format('MMMM D, h:mm A')}
            </span>
            <span className={styles.subTitle}>by {deletedFullName}</span>
          </>
        )}
      </div>
    </div>
  )
}

function getStatusColor(status) {
  if (status === 'Finished') {
    return '#66BB6A'
  } else if (status === 'Failed') {
    return '#EF5350'
  } else if (status === 'Cancelled') {
    return '#FFA726'
  } else if (
    status === 'MigrationStarted' ||
    status === 'Migrated' ||
    status === 'DeletingStarted' ||
    status === 'Deleted'
  ) {
    return '#EF4444'
  }

  return '#888888'
}

export default UploadLogRow
